export enum Language {
  EN = 'en',
  FR = 'fr',
  DE = 'de',
  ES = 'es',
  IT = 'it',
  PL = 'pl',
  PT = 'pt',
}
